export const QBO_LOGO_URL =
  "https://cdn.shopify.com/app-store/listing_images/a9755168ba32bb3e7fa95c947d11069e/icon/CPafhOnvuf0CEAE=.png";
